import { useEffect, useState } from 'react'
import Bugsnag from '@bugsnag/js'
import { trackPageView } from 'utils/tracking'
import {
  setGlobalEventProperty,
  trackInAmplitude
} from 'utils/tracking/amplitude'
import {
  AmplitudeEvent,
  EventProperty
} from 'utils/tracking/amplitude/amplitude.interface'
import { sendAffiliateEvent, AffiliateEventName } from 'utils/affiliate'
import { useRootStore } from 'stores/utils/hooks/useRootStore'
import { useStores } from 'stores/utils/hooks/useStores'
import { getPageNameFromPath } from 'utils/pages'
import { PageName } from 'stores/helpers/Navigation.interface'

export const usePageTracking = (
  onPageChange?: (page: string | PageName) => void
) => {
  const { rootStore } = useRootStore()
  const { traversal, history } = useStores()
  const [currentPage, setCurrentPage] = useState<string | undefined | PageName>(
    undefined
  )

  useEffect(() => {
    const unlisten = history.listen(({ location }) => {
      const currentPageName = getPageNameFromPath(location.pathname)
      setCurrentPage(currentPageName)

      // Call the optional callback for additional page change handling
      if (onPageChange && currentPageName) {
        onPageChange(currentPageName)
      }
    })

    return unlisten
  }, [history, onPageChange])

  useEffect(() => {
    if (currentPage) {
      Bugsnag.setContext(currentPage)
      setGlobalEventProperty(EventProperty.CurrentPage, currentPage)
      trackInAmplitude(AmplitudeEvent.ViewPage)
      trackPageView(rootStore)
      sendAffiliateEvent(AffiliateEventName.Pageview, traversal, rootStore)
    }
  }, [currentPage, rootStore, traversal])

  return { currentPage, setCurrentPage }
}
